<template>
  <div id="app">
    <h4>Grafikler</h4>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              :label="'Başlangıç tarihi'"
              style="font-weight: bold;"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            :max="new Date().toISOString().substr(0, 10)"
            @change="dateChange(date, endDate)"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate"
              :label="'Bitiş tarihi'"
              style="font-weight: bold;"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            :min="nowDate"
            :disabled="datePickerDisable"
            :max="new Date().toISOString().substr(0, 10)"
            @change="dateChange(date, endDate)"
            @input="menu3 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <h4>Sipariş Tipleri</h4>
      <v-col
        cols="12"
        md="5"
        sm="5"
        v-if="orderTypeGraphic.chartData.datasets[0].data.length > 0"
      >
        <pie-chart
          :data="orderTypeGraphic.chartData"
          :options="orderTypeGraphic.chartOptions"
        ></pie-chart>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row>
      <h4 v-if="venueGraphic.chartData.datasets[0].data.length > 0">
        En Çok Tercih Edilen Mekanlar
      </h4>
      <v-col
        cols="12"
        md="11"
        sm="11"
        v-if="venueGraphic.chartData.datasets[0].data.length > 0"
      >
        <bar-chart
          :data="venueGraphic.chartData"
          :options="venueGraphic.chartOptions"
        ></bar-chart>
      </v-col>
      <v-col cols="12" md="1" sm="1" style="position: relative;">
        <h5
          v-if="venueGraphic.chartData.datasets[0].data.length > 0"
          style="position: absolute; bottom: 17px;"
        >
          Satış (Adet)
        </h5>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row>
      <h4 v-if="productGraphic.chartData.datasets[0].data.length > 0">
        En Çok Tercih Edilen Ürünler
      </h4>
      <v-col
        cols="12"
        md="11"
        sm="11"
        v-if="productGraphic.chartData.datasets[0].data.length > 0"
      >
        <bar-chart
          :data="productGraphic.chartData"
          :options="productGraphic.chartOptions"
        ></bar-chart>
      </v-col>
      <v-col cols="12" md="1" sm="1" style="position: relative;">
        <h5
          v-if="productGraphic.chartData.datasets[0].data.length > 0"
          style="position: absolute; bottom: 17px;"
        >
          Satış (Adet)
        </h5>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PieChart from './PieChart.js'
import BarChart from './BarChart.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    PieChart,
    BarChart,
  },
  // computed:mapGetters(['allOrderTypeGraphics','allProductGraphics']),
  data: () => ({
    nowDate: '',
    datePickerDisable: true,
    venueMaxValue: 0,
    productMaxValue: 0,
    itemOrderTypes: [
      { text: 'Uzaktan Sipariş', value: 'Remote' },
      { text: 'Hemen Al', value: 'Cashierfront' },
    ],
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    orderTypeGraphic: {
      chartOptions: {
        hoverBorderWidth: 20,
        responsive: true,
      },
      chartData: {
        hoverBackgroundColor: 'red',
        hoverBorderWidth: 10,
        labels: [],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: ['#41B883', '#E46651'],
            data: [],
          },
        ],
      },
    },
    productGraphic: {
      chartOptions: {
        scales: {
          yAxes: [
            {
              barThickness: 8, // number (pixels) or 'flex'
              maxBarThickness: 8, // number (pixels)
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          // callbacks: {
          // 	label: function(tooltipItems, data) {
          // 		return '$' + tooltipItems.yLabel;
          // 	}
          // }
        },
        responsive: true,
        maintainAspectRatio: false,
        width: 200,
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Miktar',
            backgroundColor: '#4d48f9',
            data: [],
            borderWidth: 5,
          },
        ],
      },
    },
    venueGraphic: {
      chartOptions: {
        scales: {
          yAxes: [
            {
              barThickness: 8, // number (pixels) or 'flex'
              maxBarThickness: 8, // number (pixels)
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          // callbacks: {
          // 	label: function(tooltipItems, data) {
          // 		return '$' + tooltipItems.yLabel;
          // 	}
          // }
        },
        responsive: true,
        maintainAspectRatio: false,
        width: 200,
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Miktar',
            backgroundColor: '#4d48f9',
            data: [],
            borderWidth: 5,
          },
        ],
      },
    },
  }),
  methods: {
    ...mapActions(['getGraphicReports']),
    setOrderTypeGraphic(orderTypeGraphic) {
      this.orderTypeGraphic.chartData.labels = []
      this.orderTypeGraphic.chartData.datasets[0].data = []
      orderTypeGraphic.map((item) => {
        this.orderTypeGraphic.chartData.labels.push(
          this.itemOrderTypes.find((t) => t.value == item.orderType).text,
        )
        this.orderTypeGraphic.chartData.datasets.forEach((dataset) => {
          dataset.data.push(item.count)
        })
      })
    },
    setVenueGraphic(venueGraphic) {
      this.venueGraphic.chartData.labels = []
      this.venueGraphic.chartData.datasets[0].data = []
      venueGraphic.forEach((item) => {
        this.venueGraphic.chartData.labels.push(item.venueName)
        this.venueGraphic.chartData.datasets.forEach((dataset) => {
          if (item.count > this.venueMaxValue) {
            this.venueMaxValue = item.count
          }
          dataset.data.push(item.count)
          this.venueGraphic.chartOptions.scales.xAxes[0].ticks.max =
            this.venueMaxValue + 10 - ((this.venueMaxValue + 10) % 10)
        })
      })
    },
    setProductGraphic(productGraphic) {
      this.productGraphic.chartData.labels = []
      this.productGraphic.chartData.datasets[0].data = []
      productGraphic.forEach((item) => {
        this.productGraphic.chartData.labels.push(
          item.coffeeType + ', ' + item.coffeeSize + ', ' + item.milkType,
        )
        this.productGraphic.chartData.datasets.forEach((dataset) => {
          if (item.count > this.productMaxValue) {
            this.productMaxValue = item.count
          }
          console.log('MAX VALUE', this.productMaxValue)
          dataset.data.push(item.count)
          this.productGraphic.chartOptions.scales.xAxes[0].ticks.max =
            this.productMaxValue + 10 - ((this.productMaxValue + 10) % 10)
        })
      })
    },
    dateChange(startDate, endDate) {
      this.getGraphicReports({
        startDate: startDate,
        endDate: endDate,
      })
        .then((result) => {
          this.setOrderTypeGraphic(result.orderTypeGraphic)
          this.setVenueGraphic(result.venueGraphic)
          this.setProductGraphic(result.productGraphic)
        })
        .then(() => {
          this.$forceUpdate()
        })
    },
  },
  watch: {
    date: function () {
      this.nowDate = this.date
      this.datePickerDisable = false
    },
  },
  created() {
    this.getGraphicReports({
      startDate: '',
      endDate: '',
    }).then((result) => {
      this.setOrderTypeGraphic(result.orderTypeGraphic)
      this.setVenueGraphic(result.venueGraphic)
      this.setProductGraphic(result.productGraphic)
    })
  },
}
</script>

<style>
/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
